import { render, staticRenderFns } from "./MarketAppeal.vue?vue&type=template&id=1abf821c&scoped=true"
import script from "./MarketAppeal.vue?vue&type=script&lang=js"
export * from "./MarketAppeal.vue?vue&type=script&lang=js"
import style0 from "./MarketAppeal.vue?vue&type=style&index=0&id=1abf821c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abf821c",
  null
  
)

export default component.exports